import React, { useState } from 'react'
import { useIsMobile } from '../../hooks/useMediaQuery'
import EditorMobileNotice from '../common/EditorMobileNotice'

/**
 * Gates the admin visual/code editors behind a "best on a larger screen" notice
 * on phones (template + code editing isn't viable on a phone), with an
 * "open anyway" escape hatch for anyone who insists.
 */
export default function EditorMobileGuard({ children, backTo = '/admin', backLabel = 'Back to dashboard' }) {
  const isMobile = useIsMobile()
  const [override, setOverride] = useState(false)

  if (isMobile && !override) {
    return (
      <EditorMobileNotice
        backTo={backTo}
        backLabel={backLabel}
        onOpenAnyway={() => setOverride(true)}
      />
    )
  }
  return children
}
